import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const peAndEurhymics202507: BlogMetaData = {
  title: 'モンテ園の体育と︎リトミックが体験できるイベントのお知らせ',
  description:
    '2025年7月に、当園で行われている体育とリトミックを体験していただけるイベントを開催します！。各イベントでは、モンテッソーリのお仕事も体験していただけます。',
  thumbnailUrl: '/img/blog-pd-and-eurhythmics-events.webp',
  filePath: buildBlogFilePath('2025_7-pe_and_eurhythmics_events'),
  category: BLOG_CATEGORY.NEWS,
};
